import { render, staticRenderFns } from "./TradeAnalytics.vue?vue&type=template&id=16fba5c6&"
import script from "./TradeAnalytics.vue?vue&type=script&lang=js&"
export * from "./TradeAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./TradeAnalytics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports